import { InfinityLoading, Skeleton, Text } from 'ui';
import { useTransactionItemsInfiniteQuery } from 'features/transactions';
import { TransactionViewBasedOnUser } from '../../../components';

type P = {
  classNames?: string;
  givingId: string;
  title: string;
  type: 'recent' | 'top';
};

const DonorsSection = ({ givingId, title, type }: P) => {
  const pageSize = type === 'recent' ? 12 : 3;
  const order = type === 'recent' ? 'created_at' : 'amount';
  const scope = type === 'recent' ? undefined : 'highest';

  const {
    data: donorsData,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
  } = useTransactionItemsInfiniteQuery({
    filter: { order, scope, subjectId: givingId, subjectType: 'Giving' },
    pagination: { pageSize },
  });

  const donorsPayment = donorsData?.pages.flat().flatMap((givingsPaginated) => givingsPaginated.data);

  return (
    <>
      {isLoading ? (
        <Skeleton paragraph={{ rows: pageSize }} />
      ) : // eslint-disable-next-line sonarjs/no-nested-conditional -- TODO: fix later
      donorsPayment?.length ? (
        <div className="donors-section">
          <Text type="title" uppercase weight="medium">
            {title}
          </Text>
          {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases */}
          {donorsPayment?.map((donor) => (
            <div className="donors-section__list" key={donor.id}>
              <TransactionViewBasedOnUser displayMode="detailed" transaction={donor} />
            </div>
          ))}
          {type === 'recent' ? (
            <InfinityLoading hasMoreData={hasNextPage} isLoading={isFetching} onEnter={fetchNextPage} />
          ) : null}
        </div>
      ) : null}
    </>
  );
};

export default DonorsSection;
